// extracted by mini-css-extract-plugin
export default {"avatarcont":"Styles_avatarcont__CYRin","avatar":"Styles_avatar__GiwxF","avatar__image":"Styles_avatar__image__lYcMv","date":"Styles_date__lYtJX"};